import { GlobalStoreContextType } from "../context/GlobalStoreContext";
import { AreaModel } from "./Area.model";
import { MapObject } from "./MapObject";

export class Area extends AreaModel {
    static fromFeature(feature: GeoJSON.Feature, project: any, timezone: string): Area {
        return Area.fromApiObject({ id: null, project_id: project.id }, timezone);
    }

    getMapObject(globalStoreContext: GlobalStoreContextType): MapObject | null {
        const projectMapObjects = globalStoreContext.mapObjectsForProject(this.projectId || "");

        const mapObject = projectMapObjects.find(
            (mapObject) => mapObject.mappableType == "Area" && mapObject.mappableId == this.id
        );

        if (mapObject) {
            return mapObject;
        }

        return null;
    }

    name = this.areaName;
}
